import React from 'react';

import Layout from 'common/containers/Layout';
import RewardsContent from '../components/Rewards';

const RewardsPage = () => (
  <Layout heading="Rewards">
    <RewardsContent />
  </Layout>
);

export default RewardsPage;
